import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { RouterService } from '../services/router.service';
import { UserService } from '../services/user.service';

@Injectable({ providedIn: 'root' })
export class MainAuthGuard {
    constructor(
        protected userService: UserService,
        protected routerService: RouterService
    ) {}

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
        const url: string = state.url;
        return this.checkLogin(url);
    }

    protected async checkLogin(url: string): Promise<boolean> {
        if (await this.userService.isLoggedIn()) {
            return true;
        }

        window.location.href = `/#/login?returnUrl=${url}`;
        window.location.reload();
        return false;
    }
}
